import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Checkbox } from '../ui/checkbox';

const ROLES_ADMIN = ['ADMIN', 'SUPERADMIN', 'ADMINISTRADOR'];
export const esAdminRol = (user) => ROLES_ADMIN.includes((user?.rol || '').toUpperCase());

// Casilla "Sin vencimiento" de la lista blanca: solo la ve un ADMINISTRADOR.
export const SinVencimientoCheck = ({ checked, onChange, testid = 'lista-blanca-sin-vencimiento' }) => {
  const { user } = useAuth();
  if (!esAdminRol(user)) {
    return <p className="text-xs text-slate-500 mt-1">La fecha de vencimiento es obligatoria.</p>;
  }
  return (
    <label className="flex items-center gap-2 mt-2 text-sm text-slate-700 cursor-pointer select-none">
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} data-testid={testid} />
      Sin vencimiento (solo administradores)
    </label>
  );
};
